export const OrderStatusStorePickupTop = () => {
  return (
    <div className="col-lg-12">
      <div className="checkout-infoDetails">
        <h3 className="mb-0">Store Pickup Location</h3>
        <p className="checkout-infoSubtext">
          We will contact you by email or SMS as soon as your order is ready for collection
        </p>
        <div className="pickup-store-location checkout-border-content">
          <div className="row">
            <div className="col-lg-6">
              <div className="store-location">
                <h4>Store Pickup Address</h4>
                <div className="store-location-details">
                  <div className="store-location-img">
                    <span className="wes-location-selected" />
                  </div>
                  <div className="store-location-address">
                    <address>
                      WES Australasia
                      <br />
                      84-90 Parramatta Road,
                      <br />
                      Summer Hill, NSW, 2130
                      <br />
                      Australia.
                      <br />
                      Phone Number: 02 9797 9866
                    </address>
                    <div className="delivery-instructions mt-3">Basement parking available</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="store-location">
                <h4>Open Hours</h4>
                <div className="store-location-details">
                  <div className="store-location-img">
                    <span className="wes-clock" />
                  </div>
                  <div className="store-location-address">
                    <p>Monday to Friday - 8:00 AM to 5:00 PM</p>
                    <p>Saturday - 9:00 AM to 2:00 PM</p>
                    <p>Excluding Public Holidays</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Store Pickup Location */}
    </div>
  );
};
